import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { useEffect, useState } from 'react';
const Styles = labelStyles('YouTubeVideo', {
    root: css `
    position: relative;
    width: 100%;
    height: 0;
  `,
    video: css `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `,
});
export const useYouTubeIframeAPI = (youTubeId, events) => {
    useEffect(() => {
        const loadScriptTag = (scriptSrc) => {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = true;
            document.body.append(script);
        };
        const loadYouTubeIframeApi = () => {
            const youTubeIframeAPIReady = new Promise((resolve) => {
                const scriptSrc = 'https://www.youtube.com/iframe_api';
                const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
                if (!existingScript) {
                    loadScriptTag(scriptSrc);
                }
                const previousIframeApiReady = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = () => {
                    if (previousIframeApiReady) {
                        previousIframeApiReady();
                    }
                    resolve(window.YT);
                };
            });
            return youTubeIframeAPIReady;
        };
        const loadIframe = () => {
            return loadYouTubeIframeApi()
                .then((youTubeIframeAPI) => new youTubeIframeAPI.Player(`youtube-video-${youTubeId}`, {
                events,
            }))
                .catch(() => { });
        };
        if (events && Object.keys(events).length) {
            loadIframe();
        }
    }, [events, youTubeId]);
};
export const YouTubeVideo = (props) => {
    const [src, setSrc] = useState(`https://www.youtube.com/embed/${props.youTubeId}?rel=0&autoplay=${Number(props.autoplay)}&mute=${Number(props.mute)}`);
    useEffect(() => {
        var _a;
        if (props.events && ((_a = Object.keys(props.events)) === null || _a === void 0 ? void 0 : _a.length)) {
            setSrc((prevState) => `${prevState}&enablejsapi=1&origin=${window.location.origin}`);
        }
    }, [props.events]);
    useYouTubeIframeAPI(props.youTubeId, props.events);
    const style = {
        paddingBottom: `${props.aspectRatio ** -1 * 100}%`,
    };
    return (isolateComponent("div", { css: Styles.root, style: style },
        isolateComponent("iframe", { id: `youtube-video-${props.youTubeId}`, allow: props.allowFullscreen ? 'fullscreen' : undefined, css: Styles.video, frameBorder: "0", src: src, title: props.title })));
};
YouTubeVideo.defaultProps = {
    aspectRatio: 16 / 9,
    autoplay: false,
    allowFullscreen: true,
    mute: false,
};
//# sourceMappingURL=YouTubeVideo.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
